import React, { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import LoadingPage from "../Loading/loading";
import { getDeals, hideDeal } from "../../api/deals";
import { useNavigate } from "react-router-dom";
import { Cookies } from "react-cookie";

const DealComponent = (props) => {
  const navigate = useNavigate();
  const cookie = new Cookies();
  const [isSuper, setIsSuper] = useState(cookie.get("isSuper"));
  const [searchTerm, setSearchTerm] = useState("");
  const [deals, setDeals] = useState(null);
  const [dealsFinal, setDealsFinal] = useState(null);
  const [hideId, setHideId] = useState("");
  useEffect(() => {
    setDeals(null);
    setDealsFinal(null);
    DealsGet();
  }, []);

  const DealsGet = () => {
    getDeals(props.dealType).then((result) => {
      setDeals(result.data.response);
      setDealsFinal(result.data.response);
    });
  };

  const hide = (id) => {
    hideDeal(id).then((result) => {
      DealsGet();
      setHideId("");
    });
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (value) {
      setDealsFinal(
        deals.filter((deal) =>
          deal.project_name.toLowerCase().includes(value.toLowerCase()),
        ),
      );
    } else {
      setDealsFinal(deals);
    }
  };

  /*deals.filter(deal =>
        deal.developer.toLowerCase().includes(searchTerm.toLowerCase()) ||
        deal.phone.includes(searchTerm)
    )*/

  return (
    <>
      {dealsFinal === null ? (
        <LoadingPage />
      ) : (
        <div>
          <div className="search-container">
            <div className="search-input-wrapper">
              <FiSearch className="search-icon" />
              <input
                type="text"
                placeholder="Name or Phone number"
                value={searchTerm}
                onChange={handleSearch}
                className="search-input"
              />
            </div>
          </div>

          <div>Number of Deals is {dealsFinal.length}</div>

          <div className="card-cards">
            {dealsFinal?.map((deal) => (
              <div key={deal._id} className={`card-card`}>
                <div className="card-info">
                  <div>
                    <p className="line">
                      <span className="label">Franchise name:</span>{" "}
                      {deal?.user_id?.name}
                    </p>
                    <p className="line">
                      <span className="label">Franchise phone:</span>{" "}
                      {deal?.user_id?.phone}
                    </p>
                    <p className="line">
                      <span className="label">Developer:</span> {deal.developer}
                    </p>
                    <p className="line">
                      <span className="label">Project name:</span>{" "}
                      {deal.project_name}
                    </p>
                    <p className="line">
                      <span className="label">Deal value:</span>{" "}
                      {deal.deal_value}
                    </p>
                    <p className="line">
                      <span className="label">Admin Code:</span>{" "}
                      {deal?.admin_code}
                    </p>
                    <p className="line">
                      <span className="label">Create at:</span>{" "}
                      {deal?.createdAt.split("T")[0]}
                    </p>
                    {hideId === deal._id && (
                      <div
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          padding: "5px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p className="line">
                          Are you sure you want to delete this?{" "}
                        </p>
                        <div className="card-info">
                          <div className="card-actions">
                            <button
                              onClick={() => {
                                setHideId("");
                              }}
                              className="action-btn accept-btn"
                            >
                              No
                            </button>
                          </div>
                          <div className="card-actions">
                            <button
                              onClick={() => {
                                hide(deal._id);
                              }}
                              className="action-btn remove-btn"
                            >
                              Yes
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  <button
                    onClick={() => {
                      navigate(`/deals/id/${deal._id}`);
                    }}
                    className="action-btn ban-btn"
                  >
                    View
                  </button>
                  <div style={{ height: "10px" }}></div>
                  {isSuper &&
                    hideId === "" &&
                    (props.dealType === "Accept" ||
                      props.dealType === "Reject") && (
                      <button
                        onClick={() => {
                          setHideId(deal._id);
                        }}
                        className="action-btn remove-btn"
                      >
                        Delete
                      </button>
                    )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default DealComponent;
